import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import RiskColorChart from './RiskColorChart';
import { getRiskConfig, RiskLevel } from '@/utils/riskConfigurations';
interface RedundancyRiskRatingProps {
  companyName: string;
  riskLevel?: RiskLevel;
  reviewCount?: number;
}
const RedundancyRiskRating: React.FC<RedundancyRiskRatingProps> = ({
  companyName,
  riskLevel = 'Moderate Risk',
  reviewCount = 0
}) => {
  // Helper function to determine risk level based on reviews (mock implementation)
  const determineRiskLevel = (): RiskLevel => {
    // This would normally be determined by actual data analysis
    // For now, we're using the risk level passed in, or defaulting to Moderate
    return riskLevel;
  };
  const actualRiskLevel = determineRiskLevel();

  // Get risk configuration from our utility function
  const {
    icon: RiskIcon,
    color,
    textColor,
    borderColor,
    iconColor,
    description
  } = getRiskConfig(companyName, actualRiskLevel);
  return <Card className={`mb-8 border ${borderColor}`}>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium text-redflags-dark text-center">Redundancy Risk Rating</CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`${color} rounded-lg p-4 flex flex-col sm:flex-row items-center gap-4`}>
          <div className="flex-shrink-0">
            <div className={`p-3 rounded-full ${color} border ${borderColor}`}>
              <RiskIcon className={`w-6 h-6 ${iconColor}`} />
            </div>
          </div>
          
          <div>
            <h3 className={`text-lg font-semibold ${textColor}`}>{actualRiskLevel}</h3>
            <p className="text-gray-700 mt-1">{description}</p>
          </div>
        </div>
        
        {/* Add the color chart component */}
        <RiskColorChart riskLevel={actualRiskLevel} />
        
        <p className="text-sm text-gray-500 mt-4 text-center">Based on RedFlags AI powered algorithm data assessment</p>
      </CardContent>
    </Card>;
};
export default RedundancyRiskRating;